export const applicationDeleteTableColumns: any = [
  {
    display_name: "Application Name",
    key: "name",
    //   showExpand: true,
    showExpandWithText: true,
    headerStyles: {
      background: "#7593F2",
      borderRadius: "6px 0 0",
      width: "30%",
    },
  },
  {
    display_name: "Affected Scripts",
    key: "script.name",
    headerStyles: {
      background: "#7593F2",
      width: "15%",
    },
  },
  {
    display_name: "Step(s) Referenced",
    key: "scriptStep.sequence",
    headerStyles: {
      width: "15%",
      background: "#7593F2",
    },
  },
  {
    display_name: "",
    key: "map",
    _config: {
      type: "conditional-button",
      name: "Open",
      isImage: true,
      imgSrc: "../../../../assets/images/table/table-item-open.svg",
      classNames: "btn-accello-light open-btn ",
      isConditionalCheck: true,
      conditionalCheck: { key: "scriptLevel", value: true },
    },
    headerStyles: {
      background: "#7593F2",
      borderRadius: "0 6px 0 0",
      width: "10%",
    },
  },
];

export const pageDeleteTableColumns: any = [
  {
    display_name: "Page Name",
    key: "name",
    //   showExpand: true,
    showExpandWithText: true,
    headerStyles: {
      background: "#7593F2",
      borderRadius: "6px 0 0",
      width: "30%",
    },
  },
  {
    display_name: "Affected Scripts",
    key: "script.name",
    headerStyles: {
      background: "#7593F2",
      width: "15%",
    },
  },
  {
    display_name: "Step(s) Referenced",
    key: "scriptStep.sequence",
    headerStyles: {
      width: "15%",
      background: "#7593F2",
    },
  },
  {
    display_name: "",
    key: "map",
    _config: {
      type: "conditional-button",
      name: "Open",
      isImage: true,
      imgSrc: "../../../../assets/images/table/table-item-open.svg",
      classNames: "btn-accello-light open-btn ",
      isConditionalCheck: true,
      conditionalCheck: { key: "scriptLevel", value: true },
    },
    headerStyles: {
      background: "#7593F2",
      borderRadius: "0 6px 0 0",
      width: "10%",
    },
  },
];

export const uiObjectDeleteTableColumns: any = [
  {
    display_name: "Ui-Object Name",
    key: "name",
    //   showExpand: true,
    showExpandWithText: true,
    headerStyles: {
      background: "#7593F2",
      borderRadius: "6px 0 0",
      width: "30%",
    },
  },
  {
    display_name: "Affected Scripts",
    key: "script.name",
    headerStyles: {
      background: "#7593F2",
      width: "15%",
    },
  },
  {
    display_name: "Step(s) Referenced",
    key: "scriptStep.sequence",
    headerStyles: {
      width: "15%",
      background: "#7593F2",
    },
  },
  {
    display_name: "",
    key: "map",
    _config: {
      type: "conditional-button",
      name: "Open",
      isImage: true,
      imgSrc: "../../../../assets/images/table/table-item-open.svg",
      classNames: "btn-accello-light open-btn ",
      isConditionalCheck: true,
      conditionalCheck: { key: "scriptLevel", value: true },
    },
    headerStyles: {
      background: "#7593F2",
      borderRadius: "0 6px 0 0",
      width: "10%",
    },
  },
];

export const reusableScriptDeleteTableColumns: any = [
  {
    display_name: "Reusable Script Name",
    key: "name",
    //   showExpand: true,
    showExpandWithText: true,
    headerStyles: {
      background: "#7593F2",
      borderRadius: "6px 0 0",
      width: "30%",
    },
  },
  {
    display_name: "Affected Scripts",
    key: "script.name",
    headerStyles: {
      background: "#7593F2",
      width: "15%",
    },
  },
  {
    display_name: "Step(s) Referenced",
    key: "scriptStep.sequence",
    headerStyles: {
      borderRadius: "0 6px 0 0",
      width: "15%",
      background: "#7593F2",
    },
  },
];


export const reusableComponentDeleteTableColumns: any = [
  {
    display_name: "Reusable Script Name",
    key: "name",
    //   showExpand: true,
    showExpandWithText: true,
    headerStyles: {
      background: "#7593F2",
      borderRadius: "6px 0 0",
      width: "20%",
    },
  },
  {
    display_name: "Component Name",
    key: "componentName",
    //   showExpand: true,
    headerStyles: {
      background: "#7593F2",
      width: "20%",
    },
  },
  {
    display_name: "Affected Scripts",
    key: "script.name",
    headerStyles: {
      background: "#7593F2",
      width: "15%",
    },
  },
  {
    display_name: "Step(s) Referenced",
    key: "scriptStep.sequence",
    headerStyles: {
      borderRadius: "0 6px 0 0",
      width: "15%",
      background: "#7593F2",
    },
  },
];


export const operationDeleteTableColumns: any = [
  {
    display_name: "Operation Name",
    key: "name",
    //   showExpand: true,
    showExpandWithText: true,
    headerStyles: {
      background: "#7593F2",
      borderRadius: "6px 0 0",
      width: "30%",
    },
  },
  {
    display_name: "Affected Scripts",
    key: "script.name",
    headerStyles: {
      background: "#7593F2",
      width: "15%",
    },
  },
  {
    display_name: "Step(s) Referenced",
    key: "scriptStep.sequence",
    headerStyles: {
      width: "15%",
      background: "#7593F2",
    },
  },
  {
    display_name: "",
    key: "map",
    _config: {
      type: "conditional-button",
      name: "Open",
      isImage: true,
      imgSrc: "../../../../assets/images/table/table-item-open.svg",
      classNames: "btn-accello-light open-btn ",
      isConditionalCheck: true,
      conditionalCheck: { key: "scriptLevel", value: true },
    },
    headerStyles: {
      background: "#7593F2",
      borderRadius: "0 6px 0 0",
      width: "10%",
    },
  },
];


export const tdgCustomTableDeleteColumns: any = [
  {
    display_name: "Table Name",
    key: "name",
    //   showExpand: true,
    showExpandWithText: true,
    headerStyles: {
      background: "#7593F2",
      borderRadius: "6px 0 0",
      width: "30%",
    },
  },
  {
    display_name: "Affected Scripts",
    key: "script.name",
    headerStyles: {
      background: "#7593F2",
      width: "35%",
    },
  },
  {
    display_name: "",
    key: "map",
    _config: {
      type: "conditional-button",
      name: "Open",
      isImage: true,
      imgSrc: "../../../../assets/images/table/table-item-open.svg",
      classNames: "btn-accello-light open-btn ",
      isConditionalCheck: true,
      conditionalCheck: { key: "scriptLevel", value: true },
    },
    headerStyles: {
      background: "#7593F2",
      borderRadius: "0 6px 0 0",
      width: "15%",
    },
  },
];

export const validationErrorColumns: any = [
  {
    display_name: "File Name",
    key: "filename",
    //   showExpand: true,
    showExpandWithText: true,
    headerStyles: {
      background: "#7593F2",
      borderRadius: "6px 0 0",
      width: "20%",
    },
  },
  {
    display_name: "issue",
    key: "error",
    headerStyles: {
      background: "#7593F2",
      width: "75%",
    },
  }
];